import { FiUser, FiInstagram } from 'react-icons/fi';

// const StylistCard = ({ stylist, onViewPortfolio }) => {
//   return (
//     <div className="bg-gray-800 rounded-xl overflow-hidden hover:shadow-lg transition">
//       <div className="h-64 bg-gradient-to-r from-purple-900 to-pink-800 flex items-center justify-center">
//         <FiUser className="text-white text-6xl opacity-50" />
//       </div>
//       <div className="p-6">
//         <h3 className="text-xl font-semibold mb-1">{stylist.name}</h3>
//         <p className="text-purple-400 mb-4">{stylist.specialty}</p>
//         <p className="text-gray-400 text-sm mb-4">{stylist.bio}</p>
        
//         <div className="flex justify-between items-center">
//           <span className="text-gray-500 text-sm">{stylist.experience} experience</span>
          
//           <div className="flex space-x-3">
//             <a 
//               href={`https://instagram.com/${stylist.instagram}`} 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="text-gray-400 hover:text-pink-500 transition"
//             >
//               <FiInstagram size={18} />
//             </a>
//             <button 
//               onClick={() => onViewPortfolio(stylist)}
//               className="text-purple-400 hover:text-purple-300 text-sm font-medium"
//             >
//               Portfolio
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };



const StylistCard = ({ stylist, onViewPortfolio }) => {
  return (
    <div className="bg-gray-800 rounded-lg overflow-hidden shadow-lg">
      <div className="relative h-48 w-full">
        {stylist.image ? (
          <img 
            src={stylist.image} 
            alt={stylist.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-700 flex items-center justify-center">
            <FiUser className="text-4xl text-gray-400" />
          </div>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-xl font-bold">{stylist.name}</h3>
        <p className="text-purple-300">{stylist.specialty}</p>
        <p className="text-gray-400 text-sm mt-2">{stylist.experience} experience</p>
        <p className="text-gray-300 mt-3 line-clamp-2">{stylist.bio}</p>
        <div className="mt-4 flex items-center">
          <FiInstagram className="mr-2" />
          <span className="text-sm">{stylist.instagram}</span>
        </div>
        <button 
          onClick={onViewPortfolio}
          className="mt-4 w-full bg-purple-600 hover:bg-purple-700 text-white py-2 rounded"
        >
          View Portfolio
        </button>
      </div>
    </div>
  );
};

export default StylistCard;